import { SelectField } from '@calendly/ui/form/select-field';
import { TextField } from '@calendly/ui/form/text-field';
import classNames from 'classnames';
import { forwardRef } from 'react';
import ErrorMessage from 'components/core/error_message';
const flexBoxCss = "f1tk9usb";
const FlexBox = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(flexBoxCss, props.className)} />;
});
const timingOptionsBlockCss = "t5pjb75";
export const TimingOptionsBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timingOptionsBlockCss, props.className)} />;
});
export const TimingInputBlock = FlexBox;
const timingTextFieldCss = "tv9ird0";
export const TimingTextField = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(timingTextFieldCss, props.className)} />);
const timingSelectCss = "tsyis9m";
export const TimingSelect = forwardRef((props, ref) => <SelectField ref={ref} {...props} className={classNames(timingSelectCss, props.className)} />);
const whenBlockCss = "w2223ju";
export const WhenBlock = forwardRef((props, ref) => <FlexBox ref={ref} {...props} className={classNames(whenBlockCss, props.className)} />);
const whenRowCss = "wg55lpm";
export const WhenRow = forwardRef((props, ref) => <FlexBox ref={ref} {...props} className={classNames(whenRowCss, props.className)} />);
const timingErrorMessageCss = "t1harl8y";
export const TimingErrorMessage = forwardRef((props, ref) => <ErrorMessage ref={ref} {...props} className={classNames(timingErrorMessageCss, props.className)} />);
const timingBlockCss = "t14fnvw2";
export const TimingBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timingBlockCss, props.className)} />;
});
const groupBlockCss = "g98nqol";
export const GroupBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(groupBlockCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");